import { render, staticRenderFns } from "./medeelel.vue?vue&type=template&id=5cfe32f6&scoped=true"
import script from "./medeelel.vue?vue&type=script&lang=js"
export * from "./medeelel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfe32f6",
  null
  
)

export default component.exports